import { axiosInstance } from "@/helper/axios-instance";
import { useMutation } from "@tanstack/react-query";
import type { AxiosResponse } from "axios";

type Args = {
  id: string | undefined;
  fileName: string;
  contentType?: string;
  isNonAssetBalanceSheet: boolean;
};

type SuccData = {
  response: AxiosResponse<any>;
  fileName: string;
};

export function useBSPrint() {
  return useMutation({
    mutationFn: async ({ id, fileName, isNonAssetBalanceSheet }: Args) => {
      const response = await axiosInstance({
        method: "GET",
        responseType: "arraybuffer",
        url:
          
          `Salesforce/PrintBalanceSheet/${id}?isNonAssetBal=${isNonAssetBalanceSheet}`,
      });
      return { response, fileName };
    },
    onSuccess: (data: SuccData) => {
      const { response, fileName } = data;

      const blob = new Blob([response.data], { type: "application/octetstream" });

      const url = window.URL || window.webkitURL;
      const link = url.createObjectURL(blob);
      const a = document.createElement("a");
      a.setAttribute("download", fileName);
      a.setAttribute("href", link);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
  });
}
